var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluild":""}},[_c('TabViews',{attrs:{"vertical":false,"centered":false,"tabs":_vm.helpTabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }